"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _bannerSchool = _interopRequireDefault(require("@/components/bannerSchool.vue"));
var _search = _interopRequireDefault(require("@/components/college/search.vue"));
var _public = require("@/api/public/public");
var _index = require("@/api/college/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Search: _search.default,
    BannerSchool: _bannerSchool.default
  },
  props: {},
  data: function data() {
    return {
      actNum: null,
      isBack: false,
      loginDialog: false,
      isEnter: true,
      loading: false,
      codeImg: "",
      userMsg: {
        username: "",
        password: "",
        verificationCode: "",
        keyId: ""
      },
      // 登录框规则
      userRules: {
        username: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }, {
          min: 2,
          max: 18,
          message: "长度在 2 到 18 个字符",
          trigger: "blur"
        }, {
          required: true,
          pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
          message: "账号不支持特殊字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }],
        verificationCode: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }, {
          min: 4,
          max: 4,
          message: "长度在 4 个字符",
          trigger: "blur"
        }]
      },
      bgImg: require("../../assets/collegeImg/bgg.jpg"),
      navList: [{
        name: '首页',
        path: "/:code"
      }, {
        name: '专业资源库',
        path: '/majorSource'
      }, {
        name: '精品在线课',
        path: '/onlineCourse'
      }, {
        name: '虚拟仿真',
        path: '/fictitiousCourse'
      }, {
        name: '新形态教材',
        path: '/teachingMaterial'
      }
      // {name:'视频公开课',path:'/openCourse'},
      ],
      webSite: {}
    };
  },
  created: function created() {
    if (this.$route.params.code) {
      this.$store.commit('settings/getwCode', this.$route.params.code);
    }
    // this.getWebLogo();
    this.getShoolInfo();
    // 判断状态
    var e = JSON.parse(sessionStorage.getItem("info"));
    if (e) {
      this.isBack = true;
      // this.userLogin.userHd = JSON.parse(e).avatarUrl;
    } else {
      this.isBack = false;
    }
    console.log(this.$route);
  },
  methods: {
    goUrl: function goUrl(url) {
      window.open(url);
    },
    to: function to(e, j) {
      this.actNum = j;
      // console.log('eee',e)
      if (e.linkUrl) {
        window.open(e.linkUrl);
      } else if (e.name == '首页') {
        this.$router.push({
          name: 'college',
          params: {
            code: this.$store.getters.wCode
          }
        });
      } else {
        this.$router.push(e.path);
      }
    },
    // 前往后台
    backToHt: function backToHt() {
      this.$router.push({
        path: "/ht/dashboard",
        name: "Dashboard"
      });
    },
    // 显示登录弹出框
    isLogin: function isLogin() {
      this.getImgCode();
      this.loginDialog = true;
    },
    // 获取验证码
    getImgCode: function getImgCode() {
      var _this = this;
      (0, _public.getImgCode)().then(function (res) {
        _this.codeImg = "data:image/jpg;base64," + res.data.codeImage;
        _this.userMsg.keyId = res.data.keyId;
      });
    },
    // 登录
    login: function login(v) {
      var _this2 = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          var users = {
            username: _this2.userMsg.username,
            password: _this2.$md5(_this2.userMsg.password),
            realPassword: _this2.userMsg.password,
            code: _this2.userMsg.verificationCode,
            keyId: _this2.userMsg.keyId,
            urlSign: _this2.prCode
          };
          _this2.$store.dispatch("user/login", users).then(function (res) {
            _this2.loading = false;
            _this2.$router.push({
              path: "/dashboard",
              name: "Dashboard"
            });
            sessionStorage.setItem("isFlag", "true");
            _this2.$message.success("操作成功。");
            _this2.setFlag();
          }).catch(function () {
            _this2.loading = false;
            // this.$message.error("登录失败");
          });
        } else {
          return false;
        }
      });
    },
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
    },
    // 获取学校名称 id 背景图
    getShoolInfo: function getShoolInfo() {
      var _this3 = this;
      (0, _index.getShoolByCode)({
        param: this.$store.getters.wCode
      }).then(function (res) {
        if (res.code === 2000) {
          if (res.data.backgroupImge) {
            _this3.bgImg = res.data.backgroupImge;
          }
          _this3.$store.commit('settings/getwShoolInfo', res.data);
          // console.log('xuexiao',this.$store.getters.wShoolInfo)
          // this.getWebLogo()
        }
      });
    },
    // 获取版权信息
    getWebLogo: function getWebLogo() {
      var _this4 = this;
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        if (res.code === 2000) {
          _this4.webSite = res.data;
          _this4.$store.commit('settings/getProvinceId', res.data.provinceId);
          _this4.getNav();
        }
      });
    },
    // 获取导航
    getNav: function getNav() {
      var _this5 = this;
      (0, _index.getShoolNavigations)({
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id
      }).then(function (res) {
        if (res.code === 2000) {
          res.data.filter(function (i) {
            _this5.navList.push(i);
          });
          console.log('this.navList', _this5.navList);
        }
      });
    }
  }
};